<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import store from '../../../../store';
import TwTitleBar from '../../../../components/TwTitleBar';

export default {
  name: 'SkiPass',
  props: {
    bookingId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      currentBookingId: this.bookingId,
      activeTab: `/booking/${this.bookingId}/ski/pass/overview`,
      tabs: [
        {
          id: 1,
          name: this.$t('ski.pass.tabHeaders.overview'),
          route: '/booking/:bookingId/ski/pass/overview',
          total: 0,
          showTotal: true,
          disabled: false,
        },
        {
          id: 2,
          name: this.$t('ski.pass.tabHeaders.availableProducts'),
          route: '/booking/:bookingId/ski/pass/available-products',
          total: 0,
          showTotal: false,
          disabled: false,
        },
        {
          id: 3,
          name: 'Pickup places',
          route: '/booking/:bookingId/ski/pass/pickup-places',
          total: 0,
          showTotal: false,
          disabled: false,
        },
      ],
      tabMenuOverview: 1,
      pubnub: null,
    };
  },
  components: {
    TwTitleBar,
  },
  computed: {
    ...mapGetters({
      totalNumberOfSkiPassProducts: 'skipass/getTotalNumberOfSkiPassProducts',
    }),
    ...mapState({
      booking: state => state.booking.booking,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.booking.pages.ski.title'), to: '', disabled: true },
        { text: this.$t('menu.booking.pages.ski.pass.title'), to: { name: 'SkiPass' } },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ];
    },
    passMenu() {
      const tabs = this.tabs;
      if (!this.currentBookingId) {
        return tabs;
      }
      const selectedBooking = this.booking;
      if (selectedBooking) {
        for (let i = 0; i < tabs.length; i += 1) {
          tabs[i].disabled = false;
          tabs[i].route = tabs[i].route.replace(':bookingId', this.currentBookingId);
          if (tabs[i].id === this.tabMenuOverview) {
            tabs[i].total = this.totalNumberOfSkiPassProducts;
          }
        }
      }

      return tabs;
    },
  },
  methods: {
    ...mapActions({
      loadBookingStayParticipantsByStayIds: 'booking/bookingStayParticipantsByBookingStayIds',
      setBookingParticipant: 'skipass/setBookingParticipant',
    }),
  },
  mounted() {
    if (this.booking !== undefined && this.booking.id) {
      const bookingStayIds = this.booking.stays.map(stay => stay.id);
      this.loadBookingStayParticipantsByStayIds(bookingStayIds);
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.bookingId) {
      store.dispatch('skipass/passByBookingIdLoad', to.params.bookingId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container v-if="booking && booking.id" fluid>
    <tw-title-bar
      :title="$t('menu.booking.skiPassTitleWithArea')"
      :breadcrumbs="breadcrumbs"
      :booking-info="booking"
    >
    </tw-title-bar>
    <v-layout class="pt-0" row wrap>
      <v-flex class="pr-12" grow>
        <v-tabs
          v-model="activeTab"
          mandatory
          align-with-title
          grow
          fixed-tabs
          @change="setBookingParticipant(null)"
        >
          <v-tab
            v-for="tab in passMenu"
            v-bind="tab"
            :key="tab.id"
            :to="{ path: tab.route }"
            :disabled="tab.disabled"
            exact
          >
            {{ tab.name }}
            <span v-if="tab.showTotal" class="ml-1">
              ({{ tab.total }})
            </span>
          </v-tab>
          <v-tabs-items>
            <v-tab-item
              v-for="tab of tabs"
              :transition="false"
              :reverse-transition="false"
              :key="tab.id"
              :value="tab.route"
            >
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/ski/pass/SkiPass.vue